import React, { Component } from 'react';
import SoundRepository from '../../game/handlers/SoundRepository';
import '../General.css';
import './FoodCard.css';

class FoodCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isClicked: null
        };

        this.soundRepository = SoundRepository;
        this.fullName = this.props.name;
        this.shortName = this.removeParenthesis(this.props.name);
    }

    removeParenthesis = (name) => {
        if (name.includes('(') && name.includes(')')) {
            let a = name.indexOf('(');
            let b = name.indexOf(')');
            let deleteThis = name.slice(a, b + 1);
            let shortName = name.replace(deleteThis, ''); 
            return shortName;
        }
        return name;
    }

    toggleFoodCard = () => {
        this.setState({ isClicked: !this.state.isClicked });
    }

    render() {
        return (
            <div>
                <div className="flip-card">
                    <div className={`flip-card-inner ${this.state.isClicked && 'flip-card-tranform'}`}>
                        <div className="flip-card-front">
                            <div className='food'>
                                <img src={require(`../../media/images/foods/${this.props.imgName}.png`)} alt={this.props.imgName} />
                                <div className='min-description'>
                                    <h2>{this.shortName}</h2>
                                    <p>{this.props.description}</p>
                                </div>
                            </div>
                        </div>
                        <div className="flip-card-back">
                            <div className={`food  ${this.props.backgroundColor}`}>
                                <div className='full-description'>
                                    <h2 className={this.props.backgroundColor}>{this.fullName}</h2>
                                    <p className={this.props.backgroundColor}>{this.props.description}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`read-more ${this.state.isClicked && this.props.backgroundColor}`} onClick={this.toggleFoodCard}>קרא עוד</div>
            </div>
        )
    }
}

export default FoodCard;